<template>
  <el-table
    :data="pageData.outOrd.body['outOrdItem']"
    class="ik-list-table"
    height="250"
    :header-row-class-name="'ik-list-table-header-row'"
    :header-cell-class-name="'ik-list-table-header-cell'"
    :row-class-name="'ik-list-table-body-row'"
    :cell-class-name="'ik-list-table-body-cell'"
    :highlight-current-row="true"
    :stripe="true"
    :border="true"
  >
    <el-table-column
      label="药品编码"
      align="center"
      prop="materielCode"
    />
    <el-table-column
      label="药品名称"
      align="center"
      prop="materielName"
    />
    <el-table-column
      label="品质标识"
      align="center"
      prop="qualitySign"
    >
      <template #default="{row}">
        <span>{{ row["qualitySign"]|QUALITY_SIGN }}</span>
      </template>
    </el-table-column>
    <el-table-column
      label="供应商"
      align="center"
      prop="supplierName"
    />
    <el-table-column
      label="生产商"
      align="center"
      prop="manufacturerName"
    />
    <el-table-column
      prop="batchCode"
      label="批次"
      align="center"
    />
    <el-table-column
      label="数量"
      align="center"
      prop="number"
    />
  </el-table>
</template>

<script>
export default {
  name: "OutList",
  inject: ["pageData"],
  filters: {
    /**
     * 质量标识
     * @param sign
     * @returns {string}
     * @constructor
     */
    QUALITY_SIGN(sign) {
      switch (sign) {
        case "1":
          return "普通"
        case "2":
          return "精品"
        default:
          return ""
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
